import React from 'react'
import firebase from './../Firestore'
import store from '../../store';


class AgregarCarrito extends React.Component {


  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.unsubscribe2 = null;
    this.state = {
      // CREO ESTA DE MAS productosEnCarrito: []
     };
  }

async onClick(e){


  //e.currentTarget.style = "display:none"
  let producto;

  if(this.props.diseno === "pizza" && this.props.producto2Seleccionado !== 0){
       // es pizza en mitad
       producto = {
         productoId: this.props.productoSeleccionado,
         cantidad: Number(this.props.cantidadSeleccionada)/2,
         tamano: this.props.tamanoPrecioSeleccionado.tamano,
         esAdicional: false
       };
       this.unsubscribe = await this.onAgregaEnBase(producto, true);


       let producto2 = {
         productoId: this.props.producto2Seleccionado,
         cantidad: Number(this.props.cantidadSeleccionada)/2,
         tamano: this.props.tamanoPrecioSeleccionado.tamano,
         esAdicional: false
       };
       this.unsubscribe2 = await this.onAgregaEnBase(producto2);

     } else if (this.props.diseno === "pizza" && this.props.producto2Seleccionado === 0){
       // es pizza entera
       producto = {
         productoId: this.props.productoSeleccionado,
         cantidad: Number(this.props.cantidadSeleccionada),
         tamano: this.props.tamanoPrecioSeleccionado.tamano,
         esAdicional: false
       };
        this.unsubscribe = await this.onAgregaEnBase(producto);
     }

     else if(this.props.diseno === "empanada" || this.props.diseno === "generico"){
       // empanadas

       let cantEmpanadas = this.props.productosLista.length;
       if(cantEmpanadas > 0){
         let empanada = [];
         let i;
         for (i = 0; i < cantEmpanadas; i++) {
           if(Number(this.props.productosLista[i].cantidad) > 0){
               empanada[i] = {
                 productoId: this.props.productosLista[i].id,
                 cantidad: Number(this.props.productosLista[i].cantidad),
                 tamano: '',
                 esAdicional: false
               };

               if(this.props.adicionalesSeleccionados !== undefined) {
                 // hay adicionales
                 this.unsubscribe = await this.onAgregaEnBase(empanada[i], true);
               }else{
                 this.unsubscribe = await this.onAgregaEnBase(empanada[i], true);
               }

           }

         }
         if(cantEmpanadas - 1 === i){
           store.dispatch({type: "CARRITO"});
         }
       }
     }


  if(this.props.adicionalesSeleccionados !== undefined){
    console.log("entra adicionales", this.props.adicionalesSeleccionados.length)
    let cantAdicionales = this.props.adicionalesSeleccionados.length;
    if(cantAdicionales > 0){
      let adicional = [];
      let i;
      for (i = 0; i < cantAdicionales; i++) {
        adicional[i] = {
          productoId: this.props.adicionalesSeleccionados[i],
          cantidad: Number(this.props.cantidadSeleccionada),
          tamano: '',
          esAdicional: true
        };
        this.unsubscribe = await this.onAgregaEnBase(adicional[i], true);

      }
    }
  }
}



async onAgregaEnBase(item, hayAdicionales=false){
  //var esNuevo = true;
  var currentComponent = this;
  if(sessionStorage.getItem("nroPedido") === null){
    // si no hay session de pedido la crea / la borra en el checkout
    let aleatoreo = (Math.random()*1000000).toFixed();
    window.sessionStorage.setItem("nroPedido", aleatoreo.substr(0,3) +"-"+ aleatoreo.substr(-3));
  }

  var db = firebase.firestore()


  this.unsubscribe = await db.collection("pedidoDetalle").where("pedidoId", "==", sessionStorage.getItem("nroPedido")).where("productoId", "==", item.productoId).where("tamano", "==", item.tamano)
      .get()
      .then(function(querySnapshot) {
          if(querySnapshot.size === 0){
            currentComponent.agregaProductoNuevo(item);

          }else{
            querySnapshot.forEach(function(doc) {

                currentComponent.actualizaProductoAgregado(doc.id, doc.data().cantidad, item.cantidad);
            });
          }

      })
      .catch(function(error) {
          //console.log("Error getting documents: ", error);
      });



  ////

  //if(!hayAdicionales) setTimeout(function(){ store.dispatch({type: "CARRITO"}); }, 1000);
  store.dispatch({type: "CARRITO"})
}


agregaProductoNuevo(item){
    //console.log("Agrega nvo", item)
  let db = firebase.firestore()
  db.collection("pedidoDetalle").add({
      pedidoId: window.sessionStorage.getItem("nroPedido"),
      productoId: item.productoId,
      tamano: item.tamano,
      cantidad: item.cantidad,
      uid: this.props.uid,
      esAdicional: item.esAdicional,
      confirmado: false
  })
  .then(function(docRef) {
      //console.log("Document written with ID: ", docRef.id);


  })
  .catch(function(error) {
      console.error("Error adding document: ", error);
  });
}

actualizaProductoAgregado(pedidoDetalleId, cantidadActual, cantidadAdicional){
  //console.log("productoActualiza", pedidoDetalleId, cantidadActual, cantidadAdicional)
  let db = firebase.firestore()
  var Ref = db.collection("pedidoDetalle").doc(pedidoDetalleId);

  return Ref.update({
      cantidad: cantidadActual + cantidadAdicional
  })
  .then(function() {
      //console.log("Document successfully updated!");
  })
  .catch(function(error) {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });

}

  render() {
      if(this.props.productoSeleccionado === "") return ""

      return (
        <button id="btnAgregarCarrito" type="button" onClick={event => this.onClick(event)} className="btn btn-success btn-lg btn-block my-2"><i className="fas fa-shopping-cart"></i><strong> {this.props.texto ? this.props.texto : "Agregar al pedido"}</strong></button>
      )
    }

  }

export default AgregarCarrito
